import { Injectable } from "@angular/core";
import { TaskLabel, TaskListItem } from "../../taskbook-triage/taskbook.types";
import { TranslateService } from "@ngx-translate/core";


@Injectable()
export class BacklogListService {

    constructor(
        private translateService: TranslateService
    ) {}

    getAllLabels(){
        return [
            { id: '1', name: 'bug', color: '#d73a4a' },
            { id: '2', name: 'feature', color: '#0366d6' },
            { id: '3', name: 'enhancement', color: '#8250df' },
            { id: '4', name: 'documentation', color: '#007acc' },
            { id: '5', name: 'help wanted', color: '#008672' },
            { id: '6', name: 'workload', color: '#8250df' },
            { id: '7', name: 'team spirit', color: '#007acc' },
            { id: '8', name: 'office', color: '#008672' }
        ];
    }

    getLabelsForSearch(labels: TaskLabel[]): TaskLabelForSearch[] {
        const allLabel: TaskLabelForSearch = {
            id: 'all',
            name: this.translateService.instant('all_filter'),
            color: '',
            selected: true
        }
        const labelsForSearch =  labels.map((label) => {
            return {
                id: label.id,
                name: label.name,
                color: label.color,
                selected: false
            }
        });
        return [allLabel, ...labelsForSearch];
    }

    applyLabelFilters(taksItems: TaskListItem[], selectedLabels: TaskLabelForSearch[]): TaskListItem[] {
        let filteredTaksItems = taksItems;
        if(selectedLabels?.filter(label => label.id === "all")[0].selected){
            return filteredTaksItems;
        }else{
            selectedLabels?.forEach((label) => {
                if (label.selected) {
                    filteredTaksItems = filteredTaksItems.filter(item => item.task.labels.filter(taskLabel => taskLabel.name === label.name).length > 0);
                }
            });
        }
        return filteredTaksItems;
    }

    toggleLabel(selectedLabels: TaskLabelForSearch[], labelId: string) {
        const updatedLabels = selectedLabels.map((label) => {
            if(labelId === "all"){
                if(label.id === "all"){
                    return { ...label, selected: true };
                }else{
                    return { ...label, selected: false };
                }
            }else{
                if(label.id === "all"){
                    return { ...label, selected: false };
                }else if (label.id === labelId) {
                    return { ...label, selected: !label.selected };
                }
                return label;
            }
        })
        return updatedLabels;
    }
}

export class TaskLabelForSearch {
    id: string;
    name: string;
    color: string;
    selected: boolean = false
}